import { useState, useEffect } from 'react';
import { MOBILE_EDITOR_BREAKPOINT } from '../constants';

const useIsMobile = (breakpoint = MOBILE_EDITOR_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < breakpoint);

    // ResizeObserver on <html> is more reliable than resize events on iOS
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(update);
      ro.observe(document.documentElement);
      return () => ro.disconnect();
    }

    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
